export const notImplementedError = (methodName?: string) => () => {
	throw new Error(`Method ${methodName || ''} not implemented in this play contribution remote`);
};
